import { Product } from '@core/models/piramide/Product';
import { Fuente } from './Fuente';

export class Gabinete extends Product {
  $caracteristicas: {
    Controlador_RGB: number;
    Cover_fuente: number;
    Soporte_GPU_Vertical: number;
    alto: number;
    altura_ccpu: number;
    altura_cpu: number;
    ancho: number;
    ancho_maximo_vga: number;
    audio_ac97_frontal: number;
    audio_hd_frontal: number;
    cf_2x120mm_continuos: number;
    cf_2x140mm_continuos: number;
    cf_3x120mm_continuos: number;
    cf_3x140mm_continuos: number;
    cf_80mm: number;
    cf_80mm_incluidos: number;
    cf_120mm: number;
    cf_120mm_incluidos: number;
    cf_140mm: number;
    cf_140mm_incluidos: number;
    cf_200mm: number;
    cf_200mm_incluidos: number;
    cf_continuos_con_espacio_disipador: number;
    color: string;
    conector_usb20_interno: number;
    conector_usb30_interno: number;
    conector_usb31_interno: number;
    controlador_de_fans?: null;
    disponible: number;
    factor: string;
    id_fuente: number;
    id_producto: number;
    iluminacion?: null;
    kit: number;
    kit_detalle?: null;
    largo_maximo_vga: number;
    lector_tarjetas_frontal: number;
    posicion_fuente_superior: number;
    profundidad: number;
    riser: number;
    sistema_rgb: string;
    slots: number;
    tipo_de_ventana: string;
    tipo_fuente: string;
    tipo_mother: string;
    tipo_ponderado?: null;
    unidades_2_5: number;
    unidades_3_5: number;
    unidades_3_25: number;
    unidades_opticas: number;
    usb20_frontal: number;
    usb30_frontal: number;
    usb31_frontal: number;
    ventana: number;
    w: number;
    $caracteristicas_fuente: Fuente;
    back_connect?: 1 | 0;
    factor_gabinete?: string;
  };
  public constructor(product: Product) {
    super(product);
    if (product.id_subcategoria !== 7) {
      throw 'esto no es un gabinete';
    }
  }
}
